export const primaryAccountUpdatedMessage = `Your vendor's primary bank account has been updated.`;
